import { Component, Input, Optional } from '@angular/core'
import { IDataCardNotification } from '../../../../../../models/data-card.model'
import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap'
import { CmmsItemModalComponent } from '../../cmms-item-modal/cmms-item-modal.component'

@Component({
  selector: 'app-notification-data-card-items',
  templateUrl: './notification-data-card-items.component.html',
  styles: [
    `
      .table thead th,
      .table tbody td {
        font-size: 12px;
        padding: 5px 10px;
        border: 0;
      }
      .table tbody tr td {
        vertical-align: top;
      }
    `,
  ],
  standalone: false,
})
export class NotificationDataCardItemsComponent {
  @Input() notifications: IDataCardNotification[] = []
  @Input() isLoading: boolean = false
  @Input() showTooltip: boolean = true
  @Input() tooltipPlacement: 'top' | 'bottom' | 'left' | 'right' = 'right'

  constructor(
    private modalService: NgbModal,
    @Optional() private activeModalService?: NgbActiveModal,
  ) {}

  public onNotificationModalOpen(notification: string): void {
    this.activeModalService?.close()

    const modalRef: NgbModalRef = this.modalService.open(CmmsItemModalComponent, {
      size: 'md',
      windowClass: 'cmms-notification-modal-z2000',
      backdropClass: 'cmms-notification-backdrop-z2000',
    })
    modalRef.componentInstance.type = 'NO'
    modalRef.componentInstance.item = {
      name: notification,
      title: null,
      url: null,
    }
    modalRef.result.then((result) => {}).catch((res) => {})
  }
}
